export const SealTab = {
  namespaced: true,
  state: {
    selectedSealTab: ''
  },
  getters: {
    selectedSealTab: (state) => state.selectedSealTab
  },
  mutations: {
    UPDATE_SELECTED (state, payload) {
      state.selectedSealTab = payload
    }
  },
  actions: {
    action_SetSelected ({ commit }, selectedSealTab) {
      commit('UPDATE_SELECTED', selectedSealTab)
    }
  }
}
